// MyNotificationsPage — /portal/my-notifications, the avatar menu's "My notifications"
// (ticket 274). Every staff seat sets its own bell and email switches here; the same two
// sections also sit on the admin-only Org Settings Notifications tab. PortalLayout already
// sends borrower / realtor / party seats away from /portal, so no extra guard.
import React from 'react';
import PageContainer from './kit/PageContainer';
import BellPrefsSection from './org/BellPrefsSection';
import EmailPrefsSection from './org/EmailPrefsSection';

export default function MyNotificationsPage() {
  return (
    <PageContainer
      title="My notifications"
      subtitle="Choose which alerts reach your bell and your inbox."
      titleProps={{ 'data-testid': 'my-notifications-title' }}
    >
      <div className="space-y-4" data-testid="my-notifications-page">
        <BellPrefsSection />
        <EmailPrefsSection />
      </div>
    </PageContainer>
  );
}
